export default __webpack_public_path__ + "static/sidebar-99c8a635cd6b9c007de5a66be477935d.png";